module.exports = __webpack_public_path__ + "static/img/06.a0bab68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/01/06.jpg
// module id = W2sf
// module chunks = 0